var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete_outline_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Appointment-Form-6",
    transform: "translate(-610.000000, -1644.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(507.686292, 1638.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete_outline_black_24dp",
    transform: "translate(102.313708, 6.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,15.8333333 C5,16.75 5.75,17.5 6.66666667,17.5 L13.3333333,17.5 C14.25,17.5 15,16.75 15,15.8333333 L15,7.5 C15,6.58333333 14.25,5.83333333 13.3333333,5.83333333 L6.66666667,5.83333333 C5.75,5.83333333 5,6.58333333 5,7.5 L5,15.8333333 Z M7.5,7.5 L12.5,7.5 C12.9583333,7.5 13.3333333,7.875 13.3333333,8.33333333 L13.3333333,15 C13.3333333,15.4583333 12.9583333,15.8333333 12.5,15.8333333 L7.5,15.8333333 C7.04166667,15.8333333 6.66666667,15.4583333 6.66666667,15 L6.66666667,8.33333333 C6.66666667,7.875 7.04166667,7.5 7.5,7.5 Z M12.9166667,3.33333333 L12.325,2.74166667 C12.175,2.59166667 11.9583333,2.5 11.7416667,2.5 L8.25833333,2.5 C8.04166667,2.5 7.825,2.59166667 7.675,2.74166667 L7.08333333,3.33333333 L5,3.33333333 C4.54166667,3.33333333 4.16666667,3.70833333 4.16666667,4.16666667 C4.16666667,4.625 4.54166667,5 5,5 L15,5 C15.4583333,5 15.8333333,4.625 15.8333333,4.16666667 C15.8333333,3.70833333 15.4583333,3.33333333 15,3.33333333 L12.9166667,3.33333333 Z",
    id: "Shape",
    fill: "#E83E44",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.d0c8bbfe64df4eb808db7d3ba3dc6f46.svg";
export { ForwardRef as ReactComponent };